import React, { useContext, useEffect, useReducer } from 'react';
import produce from 'immer';
import classNames from 'classnames';
import styled from 'styled-components';
import { Button, Switch, Modal, Alert } from 'common/components';
import { ContentContext } from 'layout/admin/content/Content';
import { eddFieldFactory } from '../../../data/data';
import { useEddConext } from '../../../context/EddContext';
import { addRaData, checkActiveRaScore } from '../util';
import RiskItem from '../RiskItem';
import RiskAddItem from '../RiskAddItem';
import './CustomerRisk.scss';

// TODO: EDD sample data
// const sample = [
//   {
//     id: 1,
//     name: '직업',
//     order: 9996,
//     json_key: 'field_22',
//     active: true,

//     isEdd: true,
//     category: '고객 위험',
//     score: 50,
//     tree: [
//       {
//         name: '근로소득자',
//         edd_value: 0,
//         tree: [
//           { name: '급여소득자', edd_value: 0, tree: [] },
//           { name: '공무원', edd_value: 0, tree: [] },
//           { name: '교육계 종사자', edd_value: 0, tree: [] },
//           { name: '카지노/대부업 종사자', edd_value: 0, tree: [] },
//           { name: '가상자산 종사자', edd_value: 0, tree: [] },
//         ],
//       },
//       {
//         name: '자영업자',
//         edd_value: 0,
//         tree: [
//           { name: '개인사업자/자영업자', edd_value: 0, tree: [] },
//           { name: '숙박 및 요식업/여행사', edd_value: 0, tree: [] },
//           { name: '건설업', edd_value: 0, tree: [] },
//           { name: '농축수산업', edd_value: 0, tree: [] },
//           {
//             name: '전문직',
//             edd_value: 0,
//             tree: [
//               { name: '판/검사', edd_value: 0, tree: [] },
//               { name: '의사', edd_value: 0, tree: [] },
//               { name: '변호사/변리사변호사/변리사변호사/변리사', edd_value: 0, tree: [] },
//               { name: '회계사', edd_value: 0, tree: [] },
//               { name: '노무사', edd_value: 0, tree: [] },
//             ],
//           },
//           { name: '귀금속/예술품 판매업', edd_value: 0, tree: [] },
//           { name: '환전상', edd_value: 0, tree: [] },
//           { name: '전당포/대부업', edd_value: 0, tree: [] },
//           { name: '카지노', edd_value: 0, tree: [] },
//         ],
//       },
//     ],
//   },
//   {
//     id: 2,
//     name: '거래 목적',
//     order: 9996,
//     json_key: 'field_1',
//     active: true,

//     isEdd: true,
//     category: '고객 위험',
//     score: 50,
//     tree: [
//       { name: '급여 및 생활비', edd_value: 0, tree: [] },
//       { name: '저축 및 투자', edd_value: 0, tree: [] },
//       { name: '사업상 거래', edd_value: 0, tree: [] },
//       { name: '보험료 납부', edd_value: 0, tree: [] },
//       { name: '공과금 납부', edd_value: 0, tree: [] },
//       { name: '카드 대금', edd_value: 0, tree: [] },
//       { name: '대출원리금 상환', edd_value: 0, tree: [] },
//       { name: '상속 증여성 거래', edd_value: 0, tree: [] },
//     ],
//   },
// ];

const RiskContent = styled.div<{ expand: boolean }>`
  transition: max-height 0.3s ease, padding 0.3s ease;
  border-radius: 8px;
  ${({ expand }) => {
    if (expand) return `overflow: auto; max-height: 870px; padding: 8px 16px;`;
    return `overflow: hidden; max-height: 0; padding: 0 16px;`;
  }}
}}
`;

type Action =
  | { type: 'edit'; payload: boolean }
  | { type: 'expand'; payload: boolean }
  | { type: 'data'; payload: Data[] }
  | { type: 'defaultData'; payload: Data[] };

export type Data = {
  id: number;
  name: string;
  type: string;
  active: boolean;
  isAppend: boolean;
  edd_category_id: number;
  score: number;
  deletable: boolean;
  mutable: boolean;
  order: number;
  tree: { name: string; score: number; tree: Data['tree'] }[];
};
type State = {
  edit: boolean;
  expand: boolean;
  data: Data[];
  defaultData: Data[];
};

const reducer = (state: State, action: Action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case 'edit':
        draft['edit'] = action.payload;
        break;
      case 'expand':
        draft['expand'] = action.payload;
        break;
      case 'data':
        draft['data'] = action.payload;
        break;
      case 'defaultData':
        draft['defaultData'] = action.payload;
        break;
      default:
        break;
    }
  });
};

const initialState = {
  edit: false,
  expand: false,
  data: [],
  defaultData: [],
};

const [getData, setData] = eddFieldFactory();

interface Props {
  use_ra: boolean;
}
function CustomerRisk({ use_ra }: Props) {
  const { setLoading } = useContext(ContentContext);
  const { set } = Alert.Context();

  const { edit } = useEddConext();
  const { toggleEdit } = edit;
  const riskEditable = !edit.config && !edit.risk;

  const [state, setState] = useReducer(reducer, initialState);

  const loadHandler = () => {
    setLoading(true);
    // TODO: 위험 GET
    const newState = getData(1).map((el) => ({ ...el, isAppend: false }));
    setState({ type: 'data', payload: newState });
    setState({ type: 'defaultData', payload: newState });

    setLoading(false);
  };

  useEffect(() => {
    loadHandler();
  }, []);

  const submitHandler = () => {
    setLoading(true);

    // TODO: 위험 PUT, POST
    setData(state.data.map((el, i) => ({ ...el, order: i + 1 })));
    loadHandler();

    console.log('고객 위험 submitHandler', { data: state.data });
    setState({ type: 'edit', payload: false });
    toggleEdit('risk');
    setLoading(false);
    set({ success: '위험 설정이 적용되었습니다.' });
  };

  const addRaItem = (item: Data) => {
    setState({ type: 'data', payload: [...state.data, item] });
  };

  const updateRaItem = (item: Data) => {
    const nextData = state.data.map((el) => (el.id === item.id ? item : el));
    setState({ type: 'data', payload: nextData });
  };

  const removeRaItem = (item: Data) => {
    const removed = state.data.filter((el) => el.id !== item.id);
    setState({ type: 'data', payload: removed });
  };

  const totalScore = state.data.reduce((acc, cur) => acc + cur.score, 0);
  const availableScore = 100 - totalScore;
  const satisfiedScore = checkActiveRaScore(state.data) && totalScore === 100;
  const atLeastOneActive = state.data.some((el) => el.active);

  // TODO: use_ra : true => 점수체크랑 항목 active, 선택지 변경 확인
  // use_ra : false => 항목 active, 선택지 변경 확인
  const disabled = (use_ra && !satisfiedScore) || !atLeastOneActive;

  return (
    <article className="edd-setting-customer-risk">
      <div className={classNames('title', { expand: state.expand })}>
        <i
          className={classNames({ expand: state.expand })}
          onClick={() => {
            setState({ type: 'expand', payload: !state.expand });
          }}
        />
        <h4>고객 위험</h4>
        <div className="score">
          {use_ra && (
            <>
              <div>
                <span className={classNames({ hide: !state.edit })}>부여 점수</span>
                <span>{totalScore}점</span>
              </div>
              <div>
                {state.edit && (
                  <>
                    <span>남은 점수</span>
                    <span className={classNames({ error: availableScore !== 0 })}>{availableScore}점</span>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        <div className={classNames('control', { expand: state.expand })}>
          <div className="button-group">
            {state.edit ? (
              <>
                <Button
                  text="취소"
                  onClick={() => {
                    setState({ type: 'data', payload: state.defaultData });
                    setState({ type: 'edit', payload: false });
                    toggleEdit('risk');
                  }}
                />
                <Button text="저장" disabled={disabled} onClick={submitHandler} />
              </>
            ) : (
              riskEditable && (
                <Button
                  text="위험 편집"
                  onClick={() => {
                    setState({ type: 'edit', payload: true });
                    toggleEdit('risk');
                  }}
                />
              )
            )}
          </div>
        </div>
      </div>
      <RiskContent expand={state.expand}>
        <div className="item-container">
          <div className="item-list">
            {state.data.length &&
              state.data.map((item) => {
                return (
                  <React.Fragment key={item.id}>
                    <RiskItem
                      item={item}
                      edit={state.edit}
                      active={item.active}
                      use_ra={use_ra}
                      updateRaItem={updateRaItem}
                      removeRaItem={removeRaItem}
                      activeComp={
                        <Switch
                          value={item.active}
                          onChange={(value) => {
                            updateRaItem({ ...item, active: !!value, score: !value ? 0 : item.score });
                          }}
                        />
                      }
                    />
                  </React.Fragment>
                );
              })}
          </div>
          {state.edit && (
            <Modal
              content={({ closeHandler }) => (
                <RiskAddItem item={addRaData(state.data.length, 1)} addRaItem={addRaItem} closeHandler={closeHandler} />
              )}
            >
              <Button className="item-append" type="button">
                <>
                  <i />
                  항목 추가하기
                </>
              </Button>
            </Modal>
          )}
        </div>
      </RiskContent>
    </article>
  );
}

export default CustomerRisk;
